import React from 'react';
import CardPerson from './CardPerson.jsx';
import CardBoutique from './CardBoutique.jsx';

class ModalSelect extends React.Component {

    boutiqueCards() {
        return this.props.items.map((item, index) => {
            return <CardBoutique key={item.id} item={item} changeHandler={() => this.changeHandler(item)} />;
        });
    }

    personCards() {
        return this.props.items.map((item) => {
            return <CardPerson key={item.id} item={item} changeHandler={() => this.changeHandler(item)} />;
        });
    }

    changeHandler(item) {
        this.props.changeHandler(item);
        this.props.dismissHandler();
    }

    render() {
        let classes = "z-100 pin overflow-auto flex select-" + this.props.type + " modal modal-backdrop-light";
        return (
            <div className={classes} id={this.props.id}>
                <div className="modal__inner md:relative pin align-top m-auto md:h-auto justify-center flex flex-col">
                    <div className="modal__close" onClick={this.props.dismissHandler}><i className="fas fa-times"></i></div>
                    <div className="modal__ok md:hidden" onClick={this.props.dismissHandler}><i className="fas fa-check"></i></div>
                    <div className="text-center">
                        <div className="modal__title">{ this.props.title }</div>
                        <div className="modal__subtitle">{ this.props.subtitle }</div>
                        <div className="flex modal__content">
                            { this.props.type == "professional"
                                ? this.personCards()
                                : this.boutiqueCards() }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalSelect;


// WEBPACK FOOTER //
// ./scripts/components/ModalSelect.jsx